import React from 'react'
import {HashRouter, Route, Routes} from 'react-router'
import Dashboard from './components/Dashboard'
import Quiz from './components/Quiz'
import Login from './components/Login'
import Results from './components/Results'
import ScrollToTop from './components/ScrollTop'
import Label from './components/Label'
import Report from './components/Report'
import NineBox from './components/NineBox'
import ResetPassword from "./components/ResetPassword";
import ResetPasswordRequest from "./components/ResetPasswordRequest";
import Credits from './components/Credits';
import AIAdmin from './components/AIAdmin';
import PrivateRoute from './components/common/PrivateRoute';
import {IS_CHART_COMPARISON_ENABLED} from './featureFlag';
import ChartComparison from './components/ChartComparison'; // dev-only chart comparison page (flag-gated)

const AppRoutes = () => (
    <HashRouter>
        <ScrollToTop>
            <Routes>
                <Route path='/' element={<Login/>}/>
                <Route path='/login' element={<Login/>}/>
                <Route path='/quiz' element={<Quiz />}/>
                <Route path='/reset-password-request' element={<ResetPasswordRequest/>}/>
                <Route path='/reset-password/:token' element={<ResetPassword/>}/>
                <Route path='/dashboard' element={<PrivateRoute><Dashboard textoboton={'Help'}/></PrivateRoute>}/>
                <Route path='/results' element={<PrivateRoute><Results/></PrivateRoute>}/>
                <Route path='/ninebox' element={<PrivateRoute><NineBox/></PrivateRoute>}/>
                <Route path='/label/:id' element={<PrivateRoute><Label/></PrivateRoute>}/>
                <Route path='/report/:type/:id' element={<PrivateRoute><Report/></PrivateRoute>}/>
                <Route path='/credits' element={<PrivateRoute><Credits/></PrivateRoute>}/>
                <Route path='/ai-admin' element={<PrivateRoute staffOnly><AIAdmin/></PrivateRoute>}/>
                {IS_CHART_COMPARISON_ENABLED && (
                    <Route path='/chart-comparison' element={<ChartComparison/>}/>
                )}
            </Routes>
        </ScrollToTop>
    </HashRouter>
)

export default AppRoutes
